import { render, staticRenderFns } from "./history-event.vue?vue&type=template&id=1b7c2bae"
import script from "./history-event.vue?vue&type=script&lang=js"
export * from "./history-event.vue?vue&type=script&lang=js"
import style0 from "./history-event.vue?vue&type=style&index=0&id=1b7c2bae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports